module.exports = __webpack_public_path__ + "static/media/ps.658c8814.svg";